/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // LUKACHARI: the thermal-bottle gift from 450 ILS was retired on 22.09.2026 (it blocked the Bundlex bundle discount).
  // Cleanup only: a bottle our old code added automatically (hidden property _gift) is taken out of the cart,
  // so nobody who built a cart before the change pays for it by surprise.
  var nativeFetch = window.fetch.bind(window);
  function cleanup() {
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var line = 0;
        cart.items.forEach(function(item, i) {
          if (!line && item.properties && item.properties._gift) line = i + 1;
        });
        var attrs = cart.attributes || {};
        if (!line && !attrs._gift_declined) return;
        var body = line ? { line: line, quantity: 0 } : null;
        var p = body
          ? nativeFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          : nativeFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _gift_declined: '' } }) });
        p.then(function() {
          if (!line) return;
          if (location.pathname.indexOf('/cart') === 0) { location.reload(); }
          else { document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true })); }
        }).catch(function() {});
      })
      .catch(function() {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanup);
  } else {
    cleanup();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
